"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scheduleOnExit = exports.scheduleOn = exports.EXIT_SIGNALS = void 0;
const exitSignalsToCode = new Map([
    ['SIGINT', 130],
    ['SIGQUIT', 131],
    ['SIGTERM', 143],
    ['exit', 0],
]);
exports.EXIT_SIGNALS = Array.from(exitSignalsToCode.keys());
const scheduledSignalsToHooks = new Map();
function scheduleHook(hook, signal) {
    var _a;
    if (!scheduledSignalsToHooks.has(signal) && process) {
        process.on(signal, () => {
            runHooks(signal);
        });
    }
    scheduledSignalsToHooks.set(signal, [
        ...((_a = scheduledSignalsToHooks.get(signal)) !== null && _a !== void 0 ? _a : []),
        hook,
    ]);
}
function runHooks(signal) {
    const hooks = scheduledSignalsToHooks.get(signal);
    if (hooks) {
        hooks.forEach((hook, index) => {
            try {
                hook();
            }
            catch (e) {
                // ignore error and go to next hook
                console.error(`Signal ${signal} hook ${index + 1}/${hooks.length} failed`, e);
            }
        });
    }
    // TODO: not sure if needed to really do the process.exit, it seems it's ok to just return
    // if (EXIT_SIGNALS.includes(signal)) {
    //   // eslint-disable-next-line no-process-exit
    //   process.exit(exitSignalsToCode.get(signal) ?? 0)
    // }
}
function scheduleOn(hook, ...signals) {
    signals.forEach(signal => scheduleHook(hook, signal));
}
exports.scheduleOn = scheduleOn;
function scheduleOnExit(hook) {
    scheduleOn(hook, ...exports.EXIT_SIGNALS);
}
exports.scheduleOnExit = scheduleOnExit;
//# sourceMappingURL=signals.js.map